import { reduce, omit, set } from 'lodash/fp';
import { set as fpTsSet, string } from 'fp-ts';
import { createScopedReducer } from '@mews-commander/utils';
import {
    META_STATE_FAILED,
    META_STATE_STARTED,
    META_STATE_SUCCEEDED,
} from '@mews-commander/legacy-entities/src/constants';
import {
    RESERVATION_TOGGLE_CHECKED,
    RESERVATIONS_SET_CHECKED,
    RESERVATION_TOGGLE_SHOW_ALL_NOTES,
    SET_NOTE_IDS_TO_BE_DELETED,
    SET_SELECTED_RESERVATION_SERVICE_ID,
    RESERVATIONS_SET_OPENED,
    RESERVATION_TOGGLE_OPENED,
    RESERVATION_LOAD_CANCELED,
    CHANGE_TAB,
    RESERVATION_STATE_CLEANED,
    ORDER_ITEMS_FETCH_SUCCEEDED,
    ORDER_ITEMS_FETCH_FAILED,
    ORDER_ITEMS_FETCH_STARTED,
} from '../actionTypes';
import { ReservationTab } from '../../../types/reservationTab';

export const NAME = 'reservationModuleState';

const setKeysTrueReducer = (accumulator: $TSFixMe, key: $TSFixMe) => set(key, true, accumulator);

const setKeysTrue = (state: $TSFixMe, keys: $TSFixMe) => reduce(setKeysTrueReducer, state, keys);

export const INITIAL_STATE = {
    checkedReservationIds: new Set<string>(),
    openedReservationIds: {},
    showAllServiceOrderIds: {},
    noteIdsToBeDeleted: [],
    selectedReservationServiceId: null,
    canceledReservationsDataLoaded: false,
    orderItems: META_STATE_SUCCEEDED,
    tab: ReservationTab.Status,
};
type State = typeof INITIAL_STATE;

export default createScopedReducer(INITIAL_STATE, {
    [RESERVATION_STATE_CLEANED]: (state: $TSFixMe) => ({
        ...state,
        checkedReservationIds: new Set<string>(),
        openedReservationIds: {},
    }),

    [RESERVATION_TOGGLE_CHECKED]: (state: State, reservationId: string) => ({
        ...state,
        checkedReservationIds: fpTsSet.toggle(string.Eq)(reservationId)(state.checkedReservationIds),
    }),

    [RESERVATIONS_SET_CHECKED]: (
        state: State,
        { reservationIds, isChecked }: { isChecked: boolean; reservationIds: string[] }
    ) => {
        const setModify = isChecked ? fpTsSet.union : fpTsSet.difference;
        return {
            ...state,
            checkedReservationIds: setModify(string.Eq)(new Set(reservationIds))(state.checkedReservationIds),
        };
    },
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RESERVATION_TOGGLE_SHOW_ALL_NOTES]: (state, serviceOrderId) => ({
        ...state,

        showAllServiceOrderIds: state.showAllServiceOrderIds[serviceOrderId]
            ? omit(serviceOrderId, state.showAllServiceOrderIds)
            : set(serviceOrderId, true, state.showAllServiceOrderIds),
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SET_NOTE_IDS_TO_BE_DELETED]: (state, noteIds) => ({
        ...state,
        noteIdsToBeDeleted: noteIds,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SET_SELECTED_RESERVATION_SERVICE_ID]: (state, serviceId) => ({
        ...state,
        selectedReservationServiceId: serviceId,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RESERVATIONS_SET_OPENED]: (state, { reservationIds, isOpened }: $TSFixMe) => ({
        ...state,

        openedReservationIds: isOpened
            ? setKeysTrue(state.openedReservationIds, reservationIds)
            : omit(reservationIds, state.openedReservationIds),
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RESERVATION_TOGGLE_OPENED]: (state, reservationId) => ({
        ...state,

        openedReservationIds: state.openedReservationIds[reservationId]
            ? omit(reservationId, state.openedReservationIds)
            : set(reservationId, true, state.openedReservationIds),
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RESERVATION_LOAD_CANCELED]: (state, areLoaded) => ({
        ...state,
        canceledReservationsDataLoaded: areLoaded,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [CHANGE_TAB]: (state, tab) => ({
        ...state,
        tab,
    }),
    [ORDER_ITEMS_FETCH_STARTED]: ({ orderItems, ...other }: $TSFixMe) => ({
        ...other,
        orderItems: { ...orderItems, ...META_STATE_STARTED },
    }),
    [ORDER_ITEMS_FETCH_SUCCEEDED]: ({ orderItems, ...other }: $TSFixMe) => ({
        ...other,
        orderItems: { ...orderItems, ...META_STATE_SUCCEEDED },
    }),
    [ORDER_ITEMS_FETCH_FAILED]: ({ orderItems, ...other }: $TSFixMe) => ({
        ...other,
        orderItems: { ...orderItems, ...META_STATE_FAILED },
    }),
});
